const style = document.createElement('style');
style.textContent = `
  .gw-rd-popup-widget-launcher-btn--BR {
    right: auto !important;
    left: 15px !important;
  }
  @media screen and (min-width: 768px) {
    .gw-rd-popup-widget-container {
      left: 20px !important;
      right: unset !important;
    }
  }
`;

const productPageStyle = document.createElement('style');
productPageStyle.textContent = `
  @media screen and (max-width: 767px) {
    .gw-rd-popup-widget-launcher-btn--BR {
      bottom: 80px !important;
    }
  }
`;

let count = 0;
const maxRuns = 50;
const interval = setInterval(() => {
  const formInstance = document.querySelector('.gw-widget-placeholder-BR-wrapper .gw-rd-popup-widget-placeholder');
  if (formInstance) {
    const shadow = formInstance.shadowRoot;
    shadow.appendChild(style);
    if (document.querySelector('body').classList.contains('product-template')) shadow.appendChild(productPageStyle);
    clearInterval(interval);
  }
  if (count >= maxRuns) clearInterval(interval);
  count += 1;
}, 250);
